import OmniNormalizer from './omniNormalizer';
import PartnersNormalizer from './partnersNormalizer';
import CareersNormalizer from './careersNormalizer';
import DistributorsNormalizer from './distributorsNormalizer';
import PressNormalizer from './pressNormalizer';
import SupportNormalizer from './supportNormalizer';
import EbooksNormalizer from './ebooksNormalizer';
import EventsNormalizer from './eventsNormalizer';
class Normalizer {
	constructor(props) {
		this.normalizers = {
			omni: OmniNormalizer,
			partners: PartnersNormalizer,
			careers: CareersNormalizer,
			distributors: DistributorsNormalizer,
			press: PressNormalizer,
			support: SupportNormalizer,
			ebooks: EbooksNormalizer,
      events: EventsNormalizer,
		};
		this.data = props.data;
		this.app = props.app;
	}

	getNormalizedData() {
		let currNormalizer = this.normalizers[this.app];
		let normalizer = new currNormalizer(this.data);
		return normalizer.normalizedData();
	}
}
export default Normalizer;
